import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ejtxs2z3k: FaireProductEntity = {
  token: "p_7ejtxs2z3k",
  type: "product",
  name: '"Game Day" Fuzzy Chenille Clear Crossbody Bag',
  brandToken: "b_vswk7rntc2",
  brandName: "SP Sophia Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/48b7a0d25a6a1bbd4f1b04c9c07a00a0b31c575821b8398105574a90a298b7e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89252039c2dd4e47c2381b06faca39af3b30be11e4d7cd2c79b45bef7e88dfca.jpeg",
    "https://cdn.faire.com/fastly/8f151bcec0112fc833c6a4023adc89cf966caeec7af4ba079ec03878a0cd9e47.jpeg",
    "https://cdn.faire.com/fastly/418fd858dc1b8ad0f6bdf8b30267d427a1d3bd8c704c5377c7a20fa457a64587.jpeg",
    "https://cdn.faire.com/fastly/6f9f4eff0d41d901cc4cc8e755482b4b9a640c8c524e762dfdff0c9a3d755415.jpeg",
  ],
  priceDollars: 10.2,
  description:
    'Dimensions\nHeight: 6.5"\nWidth: 8.5"\nDepth: 1.5"\n(Approx. 1.4 Liters)\n\nKey Features\nDesigned for stadium-ready style, this clear crossbody bag features bold “Game Day” chenille lettering and a water-resistant transparent body that meets event entry requirements. The zippered closure and adjustable strap offer secure, hands-free functionality, while the lightweight build ensures comfort through long days of cheering and celebrating. Easy to clean and sized to carry essentials with ease.\n\nPerfect For\nIdeal for school games, stadium events, tailgates, homecoming, and pep rallies. A practical and spirited accessory for students, sports fans, cheerleaders, and game day dressers. Perfect for back-to-school shops, concert vendors, spirit gear brands, and event-focused retailers. A top pick for birthday gifting, clear bag policy compliance, and sports-ready style with a playful, confident edge.',
  tags: [],
  msrpDollars: 40.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:09.613Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
